import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class BancoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerBancoEmpresas(empresa_rut, activado, callback) {
        const inputParams = {
            entidad: {
                empresa_rut,
                activado,
            }
        };
        this.gqlclient.query({
            query: gql `
        query ($entidad: bancoInputType) {
          banco {
            obtenerBancoEmpresas(entidad: $entidad) {
              respuesta {
                registros {
                  codigo
                  nombre
                  activado
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.banco.obtenerBancoEmpresas;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltro(nombre, activado, callback) {
        const inputParams = {
            entidad: {
                nombre,
                activado
            }
        };
        this.gqlclient.query({
            query: gql `
        query ($entidad: bancoInputType) {
          banco {
            obtenerSegunFiltro(filtro: {exacto: $entidad}) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  activado
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.banco.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
}
BancoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BancoService_Factory() { return new BancoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: BancoService, providedIn: "root" });
